export default {
  validation: {
    nameRequired: "Name is required",
    emailInvalid: "Invalid email",
    roleRequired: "Please select a role",
  },
  title: "User Management",
  description: "Manage users in your organization.",
  inviteTitle: "Invite User",
  inviteDescription: "Invite users to access the AI agents of your workspaces.",
  organizationUsersTitle: "Organization Users",
  activeUsersTab: "Active Users",
  pendingInvitesTitle: "Pending Invites",
  pendingInvitesTab: "Pending Invites",
  noOrganizationUsers: "No users found in the organization",
  noInvites: "No pending invites",
  fields: {
    name: "Name",
    email: "Email",
    role: "Role",
    status: "Status",
    workspaces: "Workspaces"
  },
  roles: {
    admin: "Admin",
    user: "User",
    superadmin: "Super Admin"
  },
  selectRole: "Select a role",
  selectWorkspaces: "Select workspaces",
  sendInvite: "Send Invite",
  noName: "No Name",
  inviteSuccess: "Invitation sent successfully",
  inviteSuccessDescription: "The user will receive an email with instructions.",
  inviteError: "Failed to send invitation",
  inviteErrorDescription: "There was an error sending the invitation.",
  duplicateInviteError: "This user has already been invited.",
  usersTable: {
    deleteConfirmTitle: "Delete User",
    deleteConfirmDescription: "Are you sure you want to remove {email} from the organization?",
    deletePendingConfirmDescription: "Are you sure you want to cancel this invitation?",
    inviteDeleteSuccess: "User removed successfully",
    inviteDeleteSuccessDescription: "The user has been removed from your organization.",
    inviteDeleteError: "Failed to remove user",
    inviteDeleteErrorDescription: "There was an error removing the user."
  },
  deleteConfirmTitle: "Delete User",
  deleteConfirmDescription: "Are you sure you want to remove {email} from the organization?",
  deletePendingConfirmDescription: "Are you sure you want to cancel this invitation?",
  deleteSuccess: "User removed successfully",
  deleteSuccessDescription: "The user has been removed from your organization.",
  deleteError: "Failed to remove user",
  deleteErrorDescription: "There was an error removing the user.",
  noWorkspaces: "No workspaces linked",
  otherWorkspaces: "Other workspaces",
  workspacesList: "Workspaces list",
  tabsWorkspaces: "Workspaces",
  tabsRole: "Role",
  editUserWorkspaces: "Edit user workspaces",
  editUserWorkspacesDescription: "Select the workspaces that {name} will have access to",
  editUserWorkspacesHelp: "Check the workspaces you want to link to this user.",
  editUserRoleTitle: "Set user role",
  editUserRoleDescription: "Select the role this user will have in the organization.",
  roleAdmin: "Administrator",
  roleUser: "User",
  roleSuperAdmin: "Super Admin",
  roleSuperAdminDesc: "Full access to all organizations and workspaces",
  editUserWorkspacesButton: "Edit linked workspaces",
  editUserSettings: "Edit user settings",
  noWorkspacesInOrganization: "There are no workspaces in the organization",
  updateWorkspacesSuccess: "Saved successfully!",
  updateWorkspacesSuccessDescription: "The user settings have been saved.",
  updateWorkspacesError: "Error updating workspaces",
  updateWorkspacesErrorDescription: "An error occurred while updating the user's workspaces.",
  deleteUserTitle: "Delete user",
  deleteUserDescription: "Are you sure you want to delete {name}? This action cannot be undone.",
  deleteUserButton: "Delete user",
  deleteUserSuccess: "User deactivated",
  deleteUserSuccessDescription: "The user has been successfully deactivated from the system.",
  deleteUserError: "Error deactivating user",
  deleteUserErrorDescription: "An error occurred while trying to deactivate the user. Please try again later.",
  cannotDeleteSelf: "You cannot delete your own user",
  deactivateSuccess: "User successfully deactivated",
  deactivateSuccessDescription: "The user has been deactivated from the system",
  deactivateError: "Error deactivating user",
  deactivateErrorDescription: "An error occurred while deactivating the user",
  loadingUserData: "Loading user data..."
} as const;
